
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["preview_video_url_wrapper", "preview_video_label", "preview_video_url_field", "preview_video_file_field"]

  // connect() {
  //   this.outputTarget.textContent = 'Hello, Stimulus!'
  // }

  video_source(event) {
    console.log(event.target.value)
    console.log("custom course controller")

    if (event.target.value == "Upload") {

      this.preview_video_url_wrapperTarget.classList.remove('d-none')

      this.preview_video_file_fieldTarget.classList.remove('d-none')
      this.preview_video_url_fieldTarget.classList.add('d-none')

      this.preview_video_labelTarget.classList.remove('d-none')
      this.preview_video_labelTarget.innerHTML = 'Upload Video'

      this.preview_video_file_fieldTarget.setAttribute("required", "required")
      this.preview_video_url_fieldTarget.removeAttribute("required")

    } else if (event.target.value == "Youtube") {

      this.preview_video_url_wrapperTarget.classList.remove('d-none')

      this.preview_video_url_fieldTarget.classList.remove('d-none')
      this.preview_video_file_fieldTarget.classList.add('d-none')

      this.preview_video_labelTarget.classList.remove('d-none')
      this.preview_video_labelTarget.innerHTML = 'Youtube video url'

      this.preview_video_file_fieldTarget.removeAttribute("required")
      this.preview_video_url_fieldTarget.setAttribute("required", "required")
      this.preview_video_url_fieldTarget.setAttribute("placeholder", "Paste YouTube link here")


    } else if (event.target.value == "Vimeo") {

      this.preview_video_url_wrapperTarget.classList.remove('d-none')

      this.preview_video_url_fieldTarget.classList.remove('d-none')
      this.preview_video_file_fieldTarget.classList.add('d-none')

      this.preview_video_labelTarget.classList.remove('d-none')
      this.preview_video_labelTarget.innerHTML = 'Vimeo video url'

      this.preview_video_file_fieldTarget.removeAttribute("required")
      this.preview_video_url_fieldTarget.setAttribute("required", "required")
      this.preview_video_url_fieldTarget.setAttribute("placeholder", "Paste Vimeo link here")


    } else {

      this.preview_video_url_wrapperTarget.classList.add('d-none')

      this.preview_video_url_fieldTarget.classList.add('d-none')
      this.preview_video_file_fieldTarget.classList.add('d-none')

      this.preview_video_labelTarget.classList.add('d-none')
      this.preview_video_labelTarget.innerHTML = 'Preview video url'

      this.preview_video_file_fieldTarget.removeAttribute("required")
      this.preview_video_url_fieldTarget.removeAttribute("required")
    }
  }
}
